<template>
    <div class="d-flex flex-column boxedContent" :style="widthBox">
      <span><i class="fas fa-circle" :style="colorPoin"></i></span>
      <span class="pa-2 text-center black--text">{{name}}</span>
    </div>
</template>
<script>
export default {
  name: 'SpanArea',
  props: ['name', 'widthBox', 'colorPoin'],
  computed: {},
  methods: {}
}
</script>

<style lang="scss">
.boxedContent {
  align-items: center;
}
</style>
